import React from 'react';
import { connect } from 'react-redux';
import { connectWallet } from 'redux/actions/blockchain.action';
import { Button } from '@kambria/kambria-lego';
import CodesList from './CodesList';

function TokenPortal({ connected, connectWallet }) {
  if (connected) {
    return (
      <div className="px-4">
        <h3 className="title mt-3 mb-5">Token Portal</h3>
        <CodesList />
      </div>
    );
  }
  return (
    <React.Fragment>
      <div>Connect your wallet to continue</div>
      <Button type="primary" size="sm" onClick={() => connectWallet(true)}>
        Connect Your Wallet
      </Button>
    </React.Fragment>
  );
}

const mapStateToProps = ({ user, blockchain }) => ({
  connected: user && blockchain.account,
});

const mapDispatchToProps = {
  connectWallet,
};

export default connect(mapStateToProps, mapDispatchToProps)(TokenPortal);
